module.exports = __webpack_public_path__ + "img/Article-image22.f6518075.jpg";